module.exports = {"130529100":"巨鹿镇","130529101":"王虎寨镇","130529102":"西郭城镇","130529103":"官亭镇","130529104":"阎疃镇","130529105":"小吕寨镇","130529106":"苏家营镇","130529200":"堤村乡","130529201":"张王疃乡","130529202":"观寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130529.json
// module id = 142
// module chunks = 0